import { useCallback, useContext } from 'react';
import { useConfirmDialog } from '@bingads-webui-campaign-react/common-hooks';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export function useNonCouponCancelDialog(props) {
  const {
    uiActivity,
  } = props;
  const serverContext = useContext(ServerContext);
  const i18n = useContext(I18nContext);

  const handleConfirmDialog = useCallback(() => {
    const {
      Urls: {
        SignOutUrl = null,
      } = {},
    } = serverContext;

    uiActivity.trace(`Sign out via PMaxLiteWizardNonCouponCancelDialog: ${SignOutUrl}`);
    if (SignOutUrl) {
      window.location.href = SignOutUrl;
    }
  }, [serverContext, uiActivity]);

  return useConfirmDialog({
    title: i18n.getString(_TL_('You\'re about to cancel your setup!')),
    content: i18n.getString(_TL_('Are you sure you want to exit setup?')),
    confirmText: i18n.getString(_TL_('Yes, exit')),
    onConfirm: handleConfirmDialog,
    cancelText: i18n.getString(_TL_('No, continue setup')),
    className: 'pmax-lite-wizard-non-coupon-cancel-dialog',
  }, {
    activity: uiActivity,
    dialogName: 'PMaxLiteWizardNonCouponCancelDialog',
  });
}
